<template>
  <div class="root">
    <div class="filter">
      <div class="filter__left">
        <span class="filter__icon">&#128269;</span>
        <span class="filter__label">Filters</span>
        <el-select
          v-model="filter.product"
          placeholder="Select"
          size="default"
          class="filter__select"
        >
          <el-option
            v-for="item in products"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>

        <span class="filter__divider"></span>

        <ElCheckbox v-model="filter.withoutNickname">
          Without nickname only
        </ElCheckbox>
      </div>

      <div class="filter__right">
        <span class="filter__count-icon">&#128101;</span>
        <span class="filter__count">{{ filteredUsers.length.toLocaleString() }}/{{ totalUsers }}</span>
      </div>
    </div>

    <el-collapse v-model="activeDates" class="users-collapse">
      <el-collapse-item
        v-for="([date, list]) in groupedByDayUsers"
        :name="date"
        :class="getDateClass(date)"
      >
        <template #title>
          <div class="collapse-title">
            <span class="collapse-title__icon">&#128197;</span>
            <span class="collapse-title__date">{{ formatDateTitle(date) }}</span>
            <el-tag size="small" class="collapse-title__badge" type="info">{{ list.length }}</el-tag>
          </div>
        </template>
        <div
          v-if="activeDates.includes(date)"
          class="list"
        >
          <UserList :users="list"/>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="loading" v-if="!isInited">
      <span class="loading__spinner"></span>
      <span>Loading...</span>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import utc from "dayjs/plugin/utc"
import customParseFormat from "dayjs/plugin/customParseFormat"
import {loadProfiles} from "@/api/endpoints/profiles";
import UserList from '@/components/UserList'
import _ from 'lodash-es'
dayjs.extend(utc)
dayjs.extend(customParseFormat)

const ITEMS_PER_PAGE = 500
const LOAD_NEW_INTERVAl = 15000
const DATE_FORMAT = 'DD.MM.YYYY'

const maxLoadingDate = dayjs().subtract(6, 'months')

console.log('chain', _.chain)

export default {
  components: {
    UserList
  },

  computed: {
    products() {
      return ['all', 'business', 'driver']
    },

    minLoadedCreatedAt() {
      return _.chain(Object.values(this.rawUsers))
          .map(item => new Date(item.created_at))
          .min()
          .value()
    },

    filteredUsers() {
      return Object.values(this.rawUsers).filter(user => {
        if (this.filter.withoutNickname === true && user.nickname) {
          return false
        }
        if (this.filter.product !== 'all' && user.first_product !== this.filter.product) {
          return false
        }
        return true
      })
    },

    groupedByDayUsers() {
      return _.chain(this.filteredUsers)
          .sortBy(item => new Date(item.created_at).getTime())
          .reverse()
          .groupBy(item => dayjs.utc(item.created_at).format(DATE_FORMAT))
          .entries()
          .value()
    },
  },

  data() {
    return {
      loadNewTimeoutId: null,

      isInited: false,

      activeDates: [],

      filter: {
        withoutNickname: false,
        product: 'all'
      },

      totalUsers: 0,
      rawUsers: {}
    }
  },

  methods: {
    formatDateTitle(dateStr) {
      const date = dayjs(dateStr, DATE_FORMAT)
      const today = dayjs()
      const yesterday = dayjs().subtract(1, 'day')

      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ]
      const formatted = `${date.date()} ${months[date.month()]} ${date.year()}`

      if (date.isSame(today, 'day')) {
        return `Today, ${formatted}`
      }
      if (date.isSame(yesterday, 'day')) {
        return `Yesterday, ${formatted}`
      }
      return formatted
    },

    getDateClass(dateStr) {
      const date = dayjs(dateStr, DATE_FORMAT)
      const today = dayjs()
      const yesterday = dayjs().subtract(1, 'day')

      if (date.isSame(today, 'day')) {
        return 'collapse-item--today'
      }
      if (date.isSame(yesterday, 'day')) {
        return 'collapse-item--yesterday'
      }
      return ''
    },

    async loadUsers(maxCount = Infinity) {
      clearTimeout(this.loadNewTimeoutId)

      let total = 0
      let loadedCount = 0

      do {
        const { data } = await loadProfiles({
          order_by: '-created_at',
          offset: loadedCount,
          limit: Math.min(ITEMS_PER_PAGE, maxCount)
        })

        total = data.total
        this.totalUsers = data.total
        loadedCount += data.items.length

        data.items.forEach(profile => {
          this.rawUsers[profile.id] = profile
        })

        if(maxLoadingDate.isAfter(this.minLoadedCreatedAt)) {
          break
        }
        // list.push(...data.items)
      } while(total > loadedCount && loadedCount < maxCount)

      this.loadNewTimeoutId = setTimeout(() => {
        if(this.isInited) {
          this.loadUsers(200)
        }
      }, LOAD_NEW_INTERVAl)
    }
  },

  async created() {
    await this.loadUsers()
    this.isInited = true
  },

  beforeUnmount() {
    this.isInited = false
    if(this.loadNewTimeoutId) {
      clearTimeout(this.loadNewTimeoutId)
    }
  }
}
</script>
<style scoped>
.root {
  height: 100%;
  width: 100%;
  background-color: #fafafa;
}

.filter {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}

.filter__left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.filter__icon {
  font-size: 14px;
}

.filter__label {
  font-weight: 500;
  color: #606266;
  margin-right: 4px;
}

.filter__select {
  width: 120px;
}

.filter__divider {
  width: 1px;
  height: 20px;
  background-color: #dcdfe6;
  margin: 0 4px;
}

.filter__right {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #909399;
  font-size: 14px;
}

.filter__count-icon {
  font-size: 14px;
}

.filter__count {
  font-weight: 600;
  color: #606266;
}

.list {
  max-width: calc(100vw - 200px);
  overflow: scroll;
  box-sizing: border-box;
}

.users-collapse {
  border-top: none;
}

.collapse-title {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.collapse-title__icon {
  font-size: 14px;
  opacity: 0.7;
}

.collapse-title__date {
  font-weight: 500;
  color: #303133;
}

.collapse-title__badge {
  margin-left: 8px;
}

.collapse-item--today :deep(.el-collapse-item__header) {
  background-color: #e8f5e9;
}

.collapse-item--yesterday :deep(.el-collapse-item__header) {
  background-color: #e3f2fd;
}

.loading {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #909399;
}

.loading__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #e4e7ed;
  border-top-color: #409eff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
<style>
.users-collapse .el-collapse-item__content {
  padding: 0;
}

.users-collapse .el-collapse-item__header {
  padding: 0 16px;
  height: 48px;
  border-bottom: 1px solid #ebeef5;
}

.users-collapse .el-collapse-item__wrap {
  border-bottom: 1px solid #ebeef5;
}
</style>
